export default "__VITE_ASSET__DTQb2ugz__"